




import Vue from 'vue';
import ImportantInformationSendHistoryDetail from '@/components/important-information/important-information-send-history-detail.component.vue';

export default Vue.extend({
  components: {
    'important-information-send-history-detail': ImportantInformationSendHistoryDetail,
  },
});
